import { Component, OnInit } from '@angular/core';
import { PermitTypeService } from 'app/services/permit-type.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { VehicleLinked } from 'app/interfaces/VehicleLinked';
import { ToastrService } from 'ngx-toastr';
import { PermitTypeVehicleService } from 'app/services/permit-type-vehicle.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

declare var $;
@Component({
  selector: 'app-list-permit-type-vehicle',
  templateUrl: './list-permit-type-vehicle.component.html',
  styleUrls: ['./list-permit-type-vehicle.component.css']
})
export class ListPermitTypeVehicleComponent implements OnInit {
  permits: any;

  vehicleTypes: any = [];
  selectedPermitType: any = {};
  doctypes: any = {};
  linked: any = [];
  isChecked: boolean = false;
  refLink: any = {};
  isEdit: boolean = false;
  doctype: string = "";
  isActivated: boolean = false;
  selected = true;
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;
  page = 1;
  lblHeading = '';
  audit = { created: '', updated: '' };
  user = { LastName: '' };

  popoverTitle = 'Delete Vehicle Type vehicle Link';
  popoverMessage = 'Are you sure you want to delete Vehicle Type Vehicle Link?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading permit Type Vehicle Links...";

  public isLoading = false;
  isEmpty: boolean = false;
  code: any;
  description: any;
  constructor(
    private service: PermitTypeVehicleService, private authWebService: AuthWebService,private toastService:ToastNotificationService,
     private utility: UtilityServiceService, private toastr: ToastrService
  ) { }


  ngOnInit() {
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : ''
    this.getAllPermits();

  }
  getAllPermits() {
    this.service.getAll().subscribe(data => {
      this.permits = data;
      //console.log(data);
    });
  }

  onChange() {
    this.linked = [];
    this.isChecked = false;
    if (this.selectedPermitType.id > 0)
      this.code = this.selectedPermitType.code;
    this.description = this.selectedPermitType.description;
    this.onReloadLinks(this.selectedPermitType.id);
    this.isLoading = true;
  }
  onReloadLinks(id: number, show: boolean = true) {

    this.message = "Loading vehicle types, please wait...";
    this.isActivated = show;
    this.service.getLinkedAndUnlinkedDoctypes(id).subscribe(
      result => {
        this.doctypes = null;
        this.doctypes = result;
        this.isActivated = false;
        this.isLoading = false;
      },
      error => {
        this.isActivated = false;
        this.isLoading = false;
      }
    );
  }
  isInList(id: number) {
    let count = this.linked.length;
    for (let iter = 0; iter < count; iter++) {
      if (this.linked[iter].vehicle_type_id == id) return iter;
    }
    return -1;
  }
  onCheck(id: number) {
    let val: VehicleLinked = {
      id: undefined,
      vehicle_type_id: id,
      permit_type_id: this.selectedPermitType.id,
      is_active: true,
      date_created: new Date(),
      user_created: this.user.LastName,
      user_modified: this.user.LastName,
      date_modified: new Date()
    };
    this.isChecked = true;
    let index = this.isInList(id);
    if (index == -1) this.linked.push(val);
    else this.linked[index] = val;
  }

  onPop(id: number) {
    this.isChecked = true;
    let index = this.isInList(id);
    //console.log("remove item");
    if (index != -1) this.linked.splice(index, 1);
  }

  onDelete(id: number, doctype: string) {
    this.message = `Unlinking ${this.doctype}, please wait...`;
    this.isActivated = true;
    this.isLoading = true;
    this.service.deleteLink(id).subscribe(
      result => {
        this.isActivated = false;
        this.linked = [];
        this.onReloadLinks(this.selectedPermitType.id, false);
        // this.dialogService.addDialog(AlertComponent, { title: 'Unlink Document Type', message: `Document type ${doctype} linked to ${this.selectedPermitType.code} unlinked succesfully.`, bold: `${this.selectedPermitType.code}` });
        this.toastService.success(`vehicle type ${doctype} succesfully unlinked from ${this.selectedPermitType.code} unlinked.`, 'Unlink vehical type')

      },
      error => {
        this.isActivated = false;
      }
    );
  }

  OnSaveLinks(id) {
    let val: VehicleLinked = {
      id: undefined,
      vehicle_type_id: id,
      permit_type_id: this.selectedPermitType.id,
      is_active: true,
      date_created: new Date(),
      user_created: this.user.LastName,
      user_modified: this.user.LastName,
      date_modified: new Date()
    };
    //console.log(val);
    this.message = "Linking selected vehicle type(s), please wait...";
    this.isActivated = true;
    this.isLoading = true;
    this.service.addToLinks(val).subscribe(
      result => {
        this.isActivated = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Linking Document Type(s)', message: `Document type(s) linked to ${this.selectedPermitType.code} succesfully.`, bold: `${this.selectedPermitType.code}` });
        this.toastService.success(`vehicle type succesfully linked to ${this.selectedPermitType.code}.`, 'link vehicle type');

        this.onReloadLinks(this.selectedPermitType.id, false);
      },
      error => {
        //console.log(error);
        this.isActivated = false;
      }
    );

  }
  onEdit(id: any, doctype: any) {
    this.doctype = doctype;
    this.isEdit = true;
    this.service.getLinkById(id).subscribe(
      result => {
        this.refLink = result;
        this.refLink.DocumentType = doctype;
      },
      error => {
        //console.log(error);
      }
    );
  }
  onUpdateLink(event, id, selectedPermitType) {
    //console.log(event.target.checked);
    if (event.target.checked) {
      this.message = `Update link between ${this.doctype} and ${this.selectedPermitType.code}, please wait...`;
      this.isActivated = true;
      this.isLoading = true;
      let link: VehicleLinked = {
        id: id,
        vehicle_type_id: selectedPermitType.vehicle_type_id,
        permit_type_id: selectedPermitType.permit_type_id,
        is_active: selectedPermitType.is_active,
        date_created: selectedPermitType.date_created,
        user_created: selectedPermitType.user_created,//To be changed
        user_modified: selectedPermitType.user_created,//To be changed
        date_modified: new Date()
      };
      //console.log(link);

      this.service.updateLink(link).subscribe(
        result => {
          this.onReloadLinks(this.selectedPermitType.id, false);
          this.isEdit = this.isActivated = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'Update Document Type Link', message: `Document type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, bold: `${this.selectedPermitType.code}` });
          this.toastService.success(`Vehicle type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, 'Unlink vehicle type');
        },
        error => {
          //console.log(error);
          this.isEdit = this.isActivated = false;
        }
      );
    }
    if (!event.target.checked) {

      this.message = `Update link between ${this.doctype} and ${this.selectedPermitType.code}, please wait...`;
      this.isActivated = true;
      this.isLoading = true;
      let link: VehicleLinked = {
        id: id,
        vehicle_type_id: selectedPermitType.vehicle_type_id,
        permit_type_id: selectedPermitType.permit_type_id,
        is_active: selectedPermitType.is_active,
        date_created: selectedPermitType.date_created,
        user_created: selectedPermitType.user_created,//To be changed
        user_modified: selectedPermitType.user_created,//To be changed
        date_modified: new Date()
      };
      //console.log(link);

      this.service.updateLink(link).subscribe(
        result => {
          this.onReloadLinks(this.selectedPermitType.id, false);
          this.isEdit = this.isActivated = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'Update Document Type Link', message: `Document type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, bold: `${this.selectedPermitType.code}` });
          this.toastService.success(`vehicle type ${this.doctype} linked to ${this.selectedPermitType.code} updated succesfully.`, 'Unlink vehicle type');

        },
        error => {
          //console.log(error);
          this.isEdit = this.isActivated = false;
        }
      );
    }

  }

  onChangeHeading(change: boolean = true) {
    this.lblHeading = (change) ? 'permit Type Vehicles' : 'Delete permit Type Vehicles';
  }
  onCancel() {
    this.isEdit = false;
  }
  showDesc(event) {
    //console.log(event);

  }
}
